<template>
  <eden-filter
    :width="270"
    :properties.sync="properties"
    :disabled="disabled"
    :loading="loading"
    @reset="reset"
    @filter="filter"
  />
</template>

<script>
export default {
  name: "GardenRewardsFilter",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      properties: {
        customer_status: {
          key: "status",
          label: "Customer Status",
          type: "list",
          options: [
            {
              label: "Subscribers",
              value: "subscriber",
            },
            {
              label: "Paused",
              value: "paused",
            },
            {
              label: "Churned",
              value: "churned",
            },
            {
              label: "Prospects",
              value: "prospect",
            },
          ],
          value: [],
          searchable: false,
        },
        apples_earned: {
          key: "apples_earned",
          label: "Apples Earned",
          type: "number-range",
          options: [],
          value: [0, 0],
          searchable: false,
        },
        apples_redeemed: {
          key: "apples_redeemed",
          label: "Apples Redeemed",
          type: "number-range",
          options: [],
          value: [0, 0],
          searchable: false,
        },
        referred_signups: {
          key: "referred_signups",
          label: "Referred Signups",
          type: "number-range",
          options: [],
          value: [0, 0],
          searchable: false,
        },
        referred_subscribers: {
          key: "referred_subscribers",
          label: "Referred Subscribers",
          type: "number-range",
          options: [],
          value: [0, 0],
          searchable: false,
        },
      },
    };
  },
  computed: {
    gardeners() {
      return this.$store.getters.gardeners_list;
    },
  },
  watch: {
    clear() {
      if (this.clear) {
        this.reset();
      }
    },
  },
  methods: {
    reset() {
      Object.keys(this.properties).forEach((key) => {
        this.properties[key].value = [];
      });
    },
    filter() {
      let params = {
        params: {},
        paramsLabel: {},
      };

      Object.keys(this.properties).forEach((property) => {
        const { key, type, value } = this.properties[property];
        if (value && value.length) {
          switch (type) {
            case "list":
              params.params[key] = value[0];
              params.paramsLabel[key] = this.properties[property];
              break;
            case "list-multiple":
              params.params[key] = value;
              params.paramsLabel[key] = this.properties[property];
              break;
            case "number-range":
              if (value[0] !== value[1]) {
                params.params[key] = value;
                params.paramsLabel[key] = this.properties[property];
              }
              break;
            default:
              break;
          }
        }
      });

      if (Object.keys(params.params).length) {
        this.$emit("filter", {
          params: params.params,
          paramsLabel: params.paramsLabel,
        });
      } else {
        this.$message.info("Filtering requires at least one property");
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
